import { useContext } from 'react';
import { PortalAuthContext } from '@/stores/PortalAuthContext';

/**
 * Hook do lado paciente. Retorna `user`, `profile`, `loading` e helpers
 * (`loginWithPassword`, `logout`, `isPortalAuthenticated`).
 *
 * Não usar o `useAuth` do staff dentro do portal — lá `isAuthenticated`
 * exige `profile` do staff, que é `null` pra paciente por design (ver
 * AuthContext no Sprint 4.3).
 */
export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) {
    throw new Error('usePortalAuth deve ser usado dentro de <PortalAuthProvider>');
  }
  return ctx;
}
